import { Theme } from '@mui/material';
import { getTypographyVariants } from '@theme/styleOverrides';
import { adjustFontSize, adjustLineHeight } from '@theme/styleOverrides/typography';
import { hideScrollBars } from '@theme/styles';

export const tabsSx = {
  '&.MuiTabs-root': {
    minHeight: 'auto',
    height: '35px',
    overflow: 'unset',
  },
  '& .MuiTab-root': {
    minHeight: 'auto',
    height: '35px',
    backgroundColor: (theme: Theme) =>
      theme.palette.theme === 'lio' ? 'background.light' : `${theme.palette.background.paper}`,
    color: (theme: Theme) => (theme.palette.theme === 'lio' ? 'common.white' : 'text.main'),
    borderRadius: '8px 8px 0 0', // TODO border radius consolidation
    marginRight: '2px', // TODO typography consolidation
    fontSize: (theme: Theme) => getTypographyVariants(theme.palette.fontSize).caption.fontSize,
    lineHeight: (theme: Theme) => getTypographyVariants(theme.palette.fontSize).caption.lineHeight,
    fontWeight: 400,
    padding: '10px',
    '& .MuiChip-root': {
      backgroundColor: (theme: Theme) => (theme.palette.theme === 'lio' ? 'common.white' : 'background.light'),
      color: (theme: Theme) => (theme.palette.theme === 'lio' ? 'background.light' : 'text.main'),
      fontWeight: 700,
      height: '20px',
      cursor: 'pointer',
      border: 'none',
    },
    '&.Mui-selected': {
      backgroundColor: (theme: Theme) => (theme.palette.theme === 'lio' ? 'common.white' : 'background.light'),
      color: (theme: Theme) => (theme.palette.theme === 'lio' ? 'common.black' : 'text.main'),
      fontSize: ({ palette }: Theme) => `${adjustFontSize(12, palette.fontSize)}px`,
      lineHeight: ({ palette }: Theme) => `${adjustLineHeight(16, palette.fontSize)}px`,
      fontWeight: 400,
      '& .MuiChip-root': {
        backgroundColor: (theme: Theme) => (theme.palette.theme === 'lio' ? 'background.light' : 'background.paper'),
        color: (theme: Theme) => (theme.palette.theme === 'lio' ? 'common.white' : 'text.main'),
      },
    },
  },
  '& .MuiTabs-indicator': {
    display: 'none',
  },
} as const;

export const miniTabsSx = (theme: Theme) => ({
  '&.MuiTabs-root': {
    marginBottom: '16px',
    justifyContent: 'flex-end',

    ...getTypographyVariants(theme.palette.fontSize).caption,
    padding: 0,
    '&.Mui-selected': {
      ...getTypographyVariants(theme.palette.fontSize).caption,
      lineHeight: '16px',
      fontWeight: 700,
      color: theme.palette.secondary.main,
    },
  },
  '& .MuiTabs-indicator': {
    backgroundColor: theme.palette.secondary.main,
  },
  '& .MuiButtonBase-root': {
    minWidth: '0',
    padding: 0,
    justifyContent: 'end',
    alignItems: 'end',
  },

  '& .MuiTab-root': {
    color: theme.palette.text.main,
    marginRight: '16px',
    paddingBottom: '6px',
    fontSize: ({ palette }: Theme) => `${adjustFontSize(12, palette.fontSize)}px`,
    lineHeight: ({ palette }: Theme) => `${adjustLineHeight(16, palette.fontSize)}px`,
    fontWeight: 400,
    boxSizing: 'border-box',

    '&.Mui-selected': {
      color: theme.palette.secondary.main,
      fontSize: ({ palette }: Theme) => `${adjustFontSize(12, palette.fontSize)}px`,
      lineHeight: ({ palette }: Theme) => `${adjustLineHeight(16, palette.fontSize)}px`,
      fontWeight: 700,
    },
  },
});

// colors look good in both dark + lio standard, and can be hard coded per design
export const headerTabsSx = (theme: Theme) => ({
  '&.MuiTabs-root': {
    boxShadow: 'none',
    scrollbarGutter: 'stable',
    ...hideScrollBars,
  },
  '& .MuiTab-root': {
    color: theme.palette.primary.dark,
    fontWeight: 500,
    fontSize: 'clamp(12px, 2vw, 14px)',
    lineHeight: '24px',
    width: 'fit-content',
    paddingX: '16px',
    textWrap: 'nowrap',
    textTransform: 'none',
    background: 'none',
    margin: 0,
    flexShrink: 0,
    textAlign: 'left',
    justifyContent: 'center',
    boxSizing: 'border-box',

    '&.Mui-selected': {
      color: theme.palette.common.white,
      textShadow: `0.25px 0px 0.1px ${theme.palette.common.white}, -0.25px 0px 0.1px ${theme.palette.common.white}`,
      background: 'none',
    },
    '&:not(.Mui-selected)': {
      color: '#bfc9d1',
      fontWeight: 500,
    },
    '&:last-of-type': {
      marginRight: 0,
    },
    '&:first-of-type': {
      marginLeft: '8px',
    },
  },
  '& .MuiTabs-indicator': {
    display: 'none',
  },
  '& .MuiTouchRipple-root': {
    borderRadius: 0,
  },
  '& .MuiTouchRipple-root span': {
    borderRadius: 0,
  },
});
